import Space from 'Modules/Space';
import { number } from 'prop-types';
import React from 'react';
import {
  Placeholder,
  PlaceholderHeader,
  PlaceholderLine,
  PlaceholderParagraph,
  Segment,
} from 'semantic-ui-react';

const LoadingItems = ({ numOfItem = 3 }) => {
  return (
    <Space gap={0} width="100%">
      {Array(numOfItem)
        .fill(null)
        .map(() => (
          <Segment raised>
            <Placeholder>
              <PlaceholderHeader image>
                <PlaceholderLine />
                <PlaceholderLine />
              </PlaceholderHeader>
              <PlaceholderParagraph>
                <PlaceholderLine length="medium" />
                <PlaceholderLine length="short" />
              </PlaceholderParagraph>
            </Placeholder>
          </Segment>
        ))}
    </Space>
  );
};

export default LoadingItems;

LoadingItems.propTypes = {
  numOfItem: number,
};

LoadingItems.defaultProps = {
  numOfItem: 3,
};
